import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    dropdownMenuFilter: {
      transform: 'translate(40px,20px)',
      marginBottom: '20px',
      '& .MuiMenuItem-root': {
        color: '#3C419A',
        fontSize: '13px',
        '&:hover': {
          backgroundColor: 'rgba(202, 202, 252, 0.2)',
          color: '#3C419A',
        },
      },
      '& .MuiPaper-elevation8': {
        boxShadow: '0px 4px 10px rgba(44, 45, 62, 0.2)',
        borderRadius: '5px',
      },
    },
    filterListCloseText: {
      position: 'absolute',
      right: '15px',
      bottom: '12px',
      fontSize: '13px',
      color: '#3C419A',
      cursor: 'pointer',
    },
    filterMenuCheckbox: {
      width: '14px',
      height: '14px',
      borderRadius: '2px',
      margin: '5px 13px 5px 7px',
      border: 'solid 1px rgba(44, 45, 62, 0.8)',
      cursor: 'pointer',
      '&': {
        color: 'none',
      },
      '&.Mui-checked': {
        color: '#3C419A',
        borderColor: '#100f12',
      },
    },
    filterMenuCheckboxE: {
      width: '14px',
      height: '14px',
      border: 'solid 1px rgba(44, 45, 62, 0.8)',
      borderRadius: '2px',
      margin: '5px 13px 5px 0px',
      cursor: 'pointer',
    },
    filterListCloseIcon: {
      display: 'relative',
      margin: '0px 10px',
      width: '18px',
      color: '#3C419A',
      cursor: 'pointer',
    },
    hr: {
      margin: '5px 0px',
    },
    filterCloseText: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '2px 10px 2px 0px',
    },
    icon: {
      paddingRight: '5px',
    },
    radioButton: {
      width: '10px',
      height: '10px',
      borderRadius: '2px',
      margin: '5px 13px 5px 0px',
      cursor: 'pointer',
      '&, &.Mui-checked': {
        margin: '5px 13px 5px 0px',
        color: '#3C419A',
      },
    },
  }),
);
